/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terminology_LookupInputs */

const en_knp_terminology_lookup = /** @type {(inputs: Knp_Terminology_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP Terminology Lookup`)
};

const fr_knp_terminology_lookup = /** @type {(inputs: Knp_Terminology_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche terminologique KNP`)
};

const de_knp_terminology_lookup = /** @type {(inputs: Knp_Terminology_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP-Terminologie-Nachschlagewerk`)
};

const it_knp_terminology_lookup = /** @type {(inputs: Knp_Terminology_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca terminologica KNP`)
};

const ru_knp_terminology_lookup = /** @type {(inputs: Knp_Terminology_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск терминов KNP`)
};

const es_knp_terminology_lookup = /** @type {(inputs: Knp_Terminology_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda de terminología de KNP`)
};

const zh_cn2_knp_terminology_lookup = /** @type {(inputs: Knp_Terminology_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP术语查询`)
};

const ja_knp_terminology_lookup = /** @type {(inputs: Knp_Terminology_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNP用語検索`)
};

const hi_knp_terminology_lookup = /** @type {(inputs: Knp_Terminology_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केएनपी शब्दावली खोज`)
};

const pt_pt2_knp_terminology_lookup = /** @type {(inputs: Knp_Terminology_LookupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta de terminologia KNP`)
};

/**
* | output |
* | --- |
* | "KNP Terminology Lookup" |
*
* @param {Knp_Terminology_LookupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terminology_lookup = /** @type {((inputs?: Knp_Terminology_LookupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terminology_LookupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terminology_lookup(inputs)
	if (locale === "de") return de_knp_terminology_lookup(inputs)
	if (locale === "it") return it_knp_terminology_lookup(inputs)
	if (locale === "ru") return ru_knp_terminology_lookup(inputs)
	if (locale === "es") return es_knp_terminology_lookup(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terminology_lookup(inputs)
	if (locale === "ja") return ja_knp_terminology_lookup(inputs)
	if (locale === "hi") return hi_knp_terminology_lookup(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terminology_lookup(inputs)
	return en_knp_terminology_lookup(inputs)
});